import React from 'react';
import Button from '../../../../CoreWrappers/Button';
const prop = 'notApplicable';

export const config = (labels, action) => ({
    id: `${prop}Column`,
    label: labels.actionColumnName,
    propName: 'notApplicable',
    width: 'var(--px-175)',
    align: 'left',
    customCell: (item) => {
        const props = {
            size: 'small',
            variant: 'text-alt',
            label: labels.actionLabel,
            onClick: () => action(item.accountId)
        };

        return <Button {...props} />;
    }
});
